module.exports = __webpack_public_path__ + "static/media/rating_information3.e92e9f29.png";